import React from "react";
import { useTranslation } from "react-i18next";
import DataField from "../../utils/DataField"
import CheckIcon from "@material-ui/icons/Check"
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline"

function EmployerData(props) {

    const { credit_proposal_legal_person_key, legal_name, email, document_number, data } = props

    const { t } = useTranslation()

    const getCardIcon = (type) => {

        const colorGreen = "#73C580"
        const colorRed = "#D91A1A"
        const colorYellow = "#DDBB08"

        switch (type) {
            case "positive":
            case false:
                return <CheckIcon style={{ color: colorGreen }} />
            case "negative":
            case true:
                return <ErrorOutlineIcon style={{ color: colorRed }} />
            case "neutral":
                return <ErrorOutlineIcon style={{ color: colorYellow }} />
            default:
                return <ErrorOutlineIcon />
        }
    }

    const formatAsMoney = (value, nullCase = null) => {
        if (value == null) return nullCase
        return ("R$ " + (value).toLocaleString('de-DE', { minimumFractionDigits: 2 }))
    }

    const mapRiskClassification = (value) => {
        switch (value) {
            case 'NENHUM':
                return 'INDÍSPONÍVEL'
            case 'MUITO_BAIXO':
                return 'MUITO BAIXO'
            case 'BAIXO':
                return 'BAIXO'
            case 'MEDIO':
                return 'MÉDIO'
            case 'ALTO':
                return 'ALTO'
            case 'MUITO_ALTO':
                return 'MUITO ALTO'
            default:
                return 'INDÍSPONÍVEL'
        }
    }

    return (
        <div className="analysisCard">
            <div>
                <div style={{ display: 'flex', margin: "0 0 20px 0" }}>
                    <a
                        className={["", "link", "subtitleSize", "bold"].join(" ")}
                        style={{ textAlign: 'start' }}
                        href={`/credit-analysis-legal-person/${credit_proposal_legal_person_key}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <div className={["blueText", "subtitleSize"].join(" ")}>
                            {t("employer_analysis")}
                        </div>
                    </a>
                </div>
                <div style={{ display: 'flex', gap: '10px' }}>
                    <div className="analysisCard" style={{ marginRight: '10px', flex: '1' }}>
                        <div style={{ marginBottom: '10px' }}>
                            <strong className="blueText">
                                {t("Dados Básicos")}
                            </strong>
                        </div>
                        <div>
                            {legal_name ?
                                <DataField
                                    title={t("Razão Social")}
                                    label={legal_name ?? t("Não disponível")}
                                    size={"normalMediumSize"}
                                    titleNoWrap={false}
                                    display='block'
                                    margin='10px'
                                /> : null}
                            {email ?
                                <DataField
                                    title={t("email")}
                                    label={email ?? t("Não disponível")}
                                    size={"normalMediumSize"}
                                    titleNoWrap={false}
                                    display='block'
                                    margin='10px'
                                >
                                </DataField> : null}
                            {document_number ?
                                <DataField
                                    title={t("CNPJ")}
                                    label={document_number ?? t("Não disponível")}
                                    size={"normalMediumSize"}
                                    titleNoWrap={false}
                                    display='block'
                                    margin='10px'
                                >
                                </DataField> : null}
                            {data.matcher_foundation_date &&
                                <div style={{ alignItems: 'center' }}>
                                    <DataField
                                        title={t("Data de fundação")}
                                        label={data.matcher_foundation_date._foundation_date ?? t("Não disponível")}
                                        size={"normalMediumSize"}
                                        titleNoWrap={false}
                                        display='block'
                                        margin='10px'
                                    />
                                    <div style={{ alignItems: 'center', display: 'flex' }}>
                                        <DataField
                                            title={t("Data de fundação correspondida")}
                                            label={""}
                                            size={"normalMediumSize"}
                                            titleNoWrap={false}
                                        />
                                        {getCardIcon(data.matcher_foundation_date._foundation_date_match ? 'positive' : 'negative')}
                                    </div>
                                </div>
                            }
                            {
                                data.enricher_receita_federal_tier
                                && <>
                                    <DataField
                                        title={t("Porte Receita Federal")}
                                        label={data.enricher_receita_federal_tier._receita_federal_tier ?? t("Não disponível")}
                                        size={"normalMediumSize"}
                                        titleNoWrap={false}
                                        display='block'
                                        margin='10px'
                                    />
                                </>
                            }
                            {
                                data.checker_activity_indicators
                                && <>
                                    {
                                        (data.checker_activity_indicators?._maximum_employees !== undefined && data.checker_activity_indicators?._minimum_employees !== undefined)
                                        && <DataField
                                            title={t("Quantidade de funcionários")}
                                            label={(data.checker_activity_indicators?._maximum_employees !== 0) ? `${String(data.checker_activity_indicators?._minimum_employees)} a ${String(data.checker_activity_indicators?._maximum_employees)}` : t("Não disponível")}
                                            size={"normalMediumSize"}
                                            titleNoWrap={false}
                                            display='block'
                                            margin='10px'
                                        />
                                    }
                                    {
                                        ((data.checker_activity_indicators._annual_revenue_maximum_amount !== undefined) && (data.checker_activity_indicators._annual_revenue_maximum_amount !== undefined))
                                        && <DataField
                                            title={"Receita anual"}
                                            label={(data.checker_activity_indicators._annual_revenue_maximum_amount !== 0) ? `de ${formatAsMoney(data.checker_activity_indicators._annual_revenue_minimum_amount || 0)} a ${formatAsMoney(data.checker_activity_indicators._annual_revenue_maximum_amount || 0)}` : t("Não disponível")}
                                            size={"normalMediumSize"}
                                            titleNoWrap={false}
                                            display='block'
                                            margin='10px'
                                        />
                                    }
                                </>
                            }
                        </div>
                    </div>
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        {
                            data.checker_receita_federal_status
                            && <div className="analysisCard">
                                <div style={{ marginBottom: '10px' }}>
                                    <strong className="blueText">
                                        Receita Federal
                                    </strong>
                                </div>
                                <div style={{ alignItems: 'center', display: 'flex' }}>
                                    <DataField
                                        title={t("Documento válido")}
                                        label={""}
                                        size={"normalMediumSize"}
                                        titleNoWrap={false}
                                    />
                                    {getCardIcon(data.checker_receita_federal_status._invalid_document_number ? 'negative' : 'positive')}
                                </div>
                                <div style={{ alignItems: 'center', display: 'flex' }}>
                                    <DataField
                                        title={t("fiscal_situation")}
                                        label={""}
                                        size={"normalMediumSize"}
                                        titleNoWrap={false}
                                    />
                                    {getCardIcon(data.checker_receita_federal_status._fiscal_situation_on_receita_federal === 'regular' ? 'positive' : 'negative')}
                                </div>
                                <div style={{ alignItems: 'center', display: 'flex' }}>
                                    <DataField
                                        title={t("document_situation")}
                                        label={""}
                                        size={"normalMediumSize"}
                                        titleNoWrap={false}
                                    />
                                    {getCardIcon(data.checker_receita_federal_status._is_document_regular_on_receita_federal ? 'negative' : 'positive')}
                                </div>

                            </div>
                        }
                        {
                            data.enricher_itau_credit_score
                            && <div className="analysisCard">
                                <div style={{ marginBottom: '10px'}}>
                                    <strong className="blueText">
                                        {t("Itaú - Score de cŕedito")}
                                    </strong>
                                </div>
                                <div style={{ alignItems: 'center', display: 'flex' }}>
                                    <DataField
                                        title={t("Score")}
                                        label={data.enricher_itau_credit_score._credit_score}
                                        size={"normalMediumSize"}
                                        titleNoWrap={false}
                                    />
                                </div>
                                <div style={{ alignItems: 'center', display: 'flex' }}>
                                    <DataField
                                        title={t('risk_level')}
                                        label={mapRiskClassification(data.enricher_itau_credit_score?._risk_classification) ?? "Indisponível"}
                                        size={"normalMediumSize"}
                                        titleNoWrap={false}
                                    />
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div>
                {data.checker_cnep &&
                    <div className="analysisCard" style={{ margin: '10px 0' }} >
                        <div style={{ display: "flex" }}>
                            <div
                                className={["blueText", "subtitleSize", "bold"].join(" ")}
                                style={{ margin: "auto 0px" }}
                            >
                                CNEP - Documento na Lista de Cadastro Nacional de Empresas Punidas
                            </div>
                            <div style={{ margin: "auto 10px" }}>
                                {getCardIcon(data.checker_cnep._is_document_on_cnep_list ? 'negative' : 'positive')}
                            </div>
                        </div>
                    </div>
                }
                {data.checker_dafn &&
                    <div className="analysisCard" style={{ margin: '10px 0' }}>
                        <div style={{ display: "flex" }}>
                            <div
                                className={["blueText", "subtitleSize", "bold"].join(" ")}
                                style={{ margin: "auto 0px" }}
                            >
                                DAFN - Inscrito em dívida ativa da União e do FGTS
                            </div>
                            <div style={{ margin: "auto 10px" }}>
                                {getCardIcon(data.checker_dafn._is_document_on_dafn_list ? 'negative' : 'positive')}
                            </div>
                        </div>
                    </div>
                }
                {data.checker_slavery &&
                    <div className="analysisCard" style={{ margin: '10px 0' }}>
                        <div style={{ display: "flex" }}>
                            <div
                                className={["blueText", "subtitleSize", "bold"].join(" ")}
                                style={{ margin: "auto 0px" }}
                            >
                                Trabalho Escravo - Documento em Lista de Trabalho Escravo
                            </div>
                            <div style={{ margin: "auto 10px" }}>
                                {getCardIcon(data.checker_slavery._is_document_on_slavery_list ? 'negative' : 'positive')}
                            </div>

                        </div>
                    </div>
                }
                {data.checker_activity_indicators &&
                    <div className="analysisCard" style={{ margin: '10px 0' }}>
                        <div style={{ display: "flex" }}>
                            <div
                                className={["blueText", "subtitleSize", "bold"].join(" ")}
                                style={{ margin: "auto 0px" }}
                            >
                                Indícios de Atividade - CNPJ apresenta indícios de estar ativo
                            </div>
                            <div style={{ margin: "auto 10px" }}>
                                {getCardIcon(data.checker_activity_indicators._is_active ? 'positive' : 'negative')}
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div >
    )
}

export default EmployerData;